import { render, staticRenderFns } from "./ed-designer-canvas.component.vue?vue&type=template&id=2a1dcbcc&scoped=true&"
import script from "./ed-designer-canvas.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer-canvas.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer-canvas.component.scss?vue&type=style&index=0&id=2a1dcbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dcbcc",
  null
  
)

export default component.exports